import { Alert } from 'antd';
import { FormattedMessage } from 'react-intl';

import { useBoardData } from '../app/contexts/BoardContext';

export default function OwnCardsOnlyBanner() {
  const { ownCardsOnly } = useBoardData();

  if (!ownCardsOnly) {
    return null;
  }

  return (
    <Alert
      type="info"
      showIcon
      message={<FormattedMessage id="board.ownCardsOnly.text" />}
    />
  );
}
